var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.$site.recaptchaKey,"size":"invisible","badge":"none","load-recaptcha-script":true},on:{"expired":_vm.onCaptchaExpired,"verify":_vm.onCaptchaVerify,"error":_vm.onCatptchaError}})}
var staticRenderFns = []

export { render, staticRenderFns }